import ServiceExec from '@/common/utils/ServiceExec';
import { store } from '@/common/service/ApiList';
import { cloneDeep } from 'lodash';
import { asFormData } from '@/common/utils/ServiceSupport';
import { updateToast, customToast } from '@/common/utils/ToastServiceResult';

const { getList, detail, saveBasic, saveBusiness, savePayment, saveImages, saveNotice, saveDelivery, serviceableArea } =
  store;
const actions = {
  FETCH_LIST: async ({ state, commit }) => {
    const { params } = state;
    const { status, data } = await ServiceExec.get(getList, params);

    if (status !== 200) return;
    const { list, pageInfo } = data;
    commit('setList', list ?? []);
    commit('setPageInfo', pageInfo ?? { page: 1, limit: 10 });
  },
  FETCH_DETAIL: async ({ state, commit, rootGetters }, { storeNo }) => {
    const { userNo } = rootGetters['admin/loginData'];
    const { status, data } = await ServiceExec.get(detail(storeNo), { userNo });

    if (status == ServiceExec.status.OK) commit('setDetail', data);
    else {
      customToast(status, data, '');
      setTimeout(() => {
        location.href = '/';
      }, 2000);
    }
  },
  SAVE_BASIC: async (
    { state, commit, getters },
    params = { phone: '', hasOffline: false, tagVn: '', tagKr: '', blog: '', youtube: '' }
  ) => {
    let detail = cloneDeep(state.detail);
    const { phone, hasOffline, tagVn, tagKr, blog, youtube, supportLanguage } = params;
    detail.phone = phone;
    detail.hasOffline = hasOffline;
    detail.tagVn = tagVn;
    detail.tagKr = tagKr;
    detail.blog = blog;
    detail.youtube = youtube;
    detail.supportLanguage = supportLanguage;

    const { status, data } = await ServiceExec.post(saveBasic, detail);
    if (updateToast(status, data)) {
      const storeListState = getters['getList'];
      storeListState.forEach((e, idx) => {
        if (e.storeNo === detail.storeNo) {
          storeListState[idx].hasOffline = hasOffline;
        }
      });

      commit('setBasic', params);
    }
  },
  SAVE_BUSINESS: async ({ state, commit, getters }, params) => {
    let detail = cloneDeep(state.detail);
    const {
      isShow,
      isWork,
      isDeliverable,
      isChattable,
      isQueryable,
      businessDays,
      breakTimes,
      holidays,
      minimumDeliveryDuration,
      maximumDeliveryDuration,
      isSupportDelivery,
      isSupportPacking,
      isSupportVisit,
      ifAcceptDelivery,
      exceedMinutes,
      discountWhenPack,
      minimumPriceForDelivery,
      businessDaysModified,
      breakTimesModified,
      holidaysModified
    } = params;

    detail.isShow = isShow;
    detail.isWork = isWork;
    detail.isDeliverable = isDeliverable;
    detail.isChattable = isChattable;
    detail.isQueryable = isQueryable;
    detail.businessDays = businessDays;
    detail.breakTimes = breakTimes;
    detail.holidays = holidays;
    detail.minimumDeliveryDuration = minimumDeliveryDuration;
    detail.maximumDeliveryDuration = maximumDeliveryDuration;
    detail.isSupportDelivery = isSupportDelivery;
    detail.isSupportPacking = isSupportPacking;
    detail.isSupportVisit = isSupportVisit;
    detail.ifAcceptDelivery = ifAcceptDelivery;
    detail.exceedMinutes = exceedMinutes;
    detail.discountWhenPack = discountWhenPack;
    detail.minimumPriceForDelivery = minimumPriceForDelivery;
    detail.businessDaysModified = businessDaysModified;
    detail.breakTimesModified = breakTimesModified;
    detail.holidaysModified = holidaysModified;

    const { status, data } = await ServiceExec.put(saveBusiness, detail);
    if (updateToast(status, data)) {
      const storeListState = getters['getList'];
      storeListState.forEach((e, idx) => {
        if (e.storeNo === detail.storeNo) {
          storeListState[idx].isWork = isWork;
          storeListState[idx].isChattable = isChattable;
        }
      });
      commit('setBusiness', params);
    }
  },
  SAVE_PAYMENT: async ({ state, commit }, params) => {
    let detail = cloneDeep(state.detail);
    const { isViaCash, isViaCard, isViaAutomaticWithdrawal, isViaOnlinePayment, storeAccounts, isPointAvailable } =
      params;

    detail.isViaCash = isViaCash;
    detail.isViaCard = isViaCard;
    detail.isViaAutomaticWithdrawal = isViaAutomaticWithdrawal;
    detail.isViaOnlinePayment = isViaOnlinePayment;
    detail.storeAccounts = storeAccounts;
    detail.isPointAvailable = isPointAvailable;

    const { status, data } = await ServiceExec.put(savePayment, detail);
    if (updateToast(status, data)) commit('setPayment', params);
  },
  SAVE_NOTICE: async (
    { state, commit },
    params = {
      introduceKr: '',
      introduceVn: '',
      introduceEn: '',
      storeNoticeKr: '',
      storeNoticeVn: '',
      storeNoticeEn: ''
    }
  ) => {
    let detail = cloneDeep(state.detail);
    detail.introduceKr = params.introduceKr;
    detail.introduceVn = params.introduceVn;
    detail.introduceEn = params.introduceEn;
    detail.storeNoticeKr = params.storeNoticeKr;
    detail.storeNoticeVn = params.storeNoticeVn;
    detail.storeNoticeEn = params.storeNoticeEn;

    const { status, data } = await ServiceExec.put(saveNotice, detail);
    if (updateToast(status, data)) commit('setNotices', params);
  },
  SAVE_IMAGES: async ({ state, commit }, params) => {
    const { status, data } = await ServiceExec.post(saveImages, asFormData(params));

    if (updateToast(status, data)) {
      commit('setSavedImages', data);
      return data;
    }

    return [];
  },
  SAVE_TIP: async (
    { state, commit },
    params = {
      baseDeliveryFee: 0,
      baseDeliveryFeeLimit: 0,
      increaseDeliveryFeePer: 0,
      additionalDeliveryFee: 0,
      maximumDeliveryFee: 0,
      noDeliveryFeeWhen: 0,
      isNegoDeliveryFee: false
    }
  ) => {
    let detail = cloneDeep(state.detail);

    detail.baseDeliveryFee = params.baseDeliveryFee;
    detail.baseDeliveryFeeLimit = params.baseDeliveryFeeLimit;
    detail.increaseDeliveryFeePer = params.increaseDeliveryFeePer;
    detail.additionalDeliveryFee = params.additionalDeliveryFee;
    detail.maximumDeliveryFee = params.maximumDeliveryFee;
    detail.noDeliveryFeeWhen = params.noDeliveryFeeWhen;
    detail.isNegoDeliveryFee = params.isNegoDeliveryFee;

    const { status, data } = await ServiceExec.put(saveDelivery, detail);
    if (updateToast(status, data)) commit('setTips', params);
  },
  FETCH_SERVICEABLE_AREA: async ({ state, commit }) => {
    const { storeNo } = state.detail;
    const { status, data } = await ServiceExec.get(serviceableArea(storeNo));

    const mocking = [
      { lat: 37.56729204102779, lng: 127.21249867089847 },
      { lat: 37.451819333008636, lng: 127.2193651259766 },
      { lat: 37.44091646217787, lng: 126.94333363183597 },
      { lat: 37.519202958984216, lng: 126.8842821181641 },
      { lat: 37.67479945313906, lng: 126.91449452050784 }
    ];
    if (status === 200) commit('setServiceableArea', data);
  }
};

export default actions;
